<template>
    <div class="NodeEditor SupporterNodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :id="node.id"
            :slug="node.slug"
            :type="node.type"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <div class="scroll-container fci-scrollbar">
            <ScenarioCard name="Prompt">
                <PromptEditor v-model="node.config.prompt" @save="saveNode"></PromptEditor>
            </ScenarioCard>
            <ScenarioCard name="Phone">
                <ApiParameterEditor
                    :items.sync="node.config.phoneList"
                    key-label="Name"
                    value-label="Phone"
                    data-format="list"
                    :editable="isEdit"
                    @save="saveNode"
                ></ApiParameterEditor>
            </ScenarioCard>
        </div>
        <NodeFooterEditor
            :actions-not-use="[
                NodeEditorMenuCode.ADD_SETTING,
                NodeEditorMenuCode.ADD_NLP_CONFIG,
                NodeEditorMenuCode.ADD_API,
                NodeEditorMenuCode.ADD_LUA,
                NodeEditorMenuCode.ADD_SET_USER_ATTRIBUTE
                ]"
            @menuSelect="onMenuSelect($event)"
        ></NodeFooterEditor>
    </div>
</template>

<script>
import NodeEditor from "@/views/Scenario/NodeEditor/NodeEditor";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard";
import NodeHeaderEditor from "@/views/Scenario/NodeEditor/common/NodeHeaderEditor";
import ApiParameterEditor from "@/views/Scenario/NodeEditor/common/ApiParameterEditor";
import NodeSaveStatus from "@/views/Scenario/NodeEditor/NodeSaveStatus";
import NodeFooterEditor from "@/views/Scenario/NodeEditor/common/NodeFooterEditor";
import PromptEditor from "@/views/Scenario/NodeEditor/process/PromptEditor";
import {mapState} from "vuex";
import ScenarioService from "@/services/scenario.service";

const {NodeEditorMenuCode} = ScenarioService
export default {
    name: "SupporterNodeEditor",
    extends: NodeEditor,
    components: {
        NodeFooterEditor,
        ScenarioCard,
        NodeHeaderEditor,
        ApiParameterEditor,
        NodeSaveStatus,
        PromptEditor
    },
    computed: {
        ...mapState({
            isEditable: () => ScenarioService.isEditable()
        })
    },
    data() {
        return {
            NodeEditorMenuCode
        }
    },
    methods: {
        validateNodeData() {
            if (!this.node.name) {
                return 'Name not valid'
            }
            let config = this.node.config
            if (!config.prompt) {
                return 'Prompt not valid'
            }
            if (config.rePromptList) {
                for (let rePrompt of config.rePromptList) {
                    if (!rePrompt.name) {
                        return 'RePrompt name not valid'
                    }
                    if (!rePrompt.prompt) {
                        return 'RePrompt content not valid'
                    }
                    let validateConditionList = this.validateConditionList(rePrompt.conditionList)
                    if (validateConditionList !== true) {
                        return validateConditionList
                    }
                }
            }
            return true
        }
    }
}
</script>

<style scoped lang="scss">
@import "src/views/Scenario/NodeEditor/NodeEditor";
</style>
